import Homepage from "../../../pages/Homepage/"
import PermissionDenied from "../../../pages/PermissionDenied"
import FormViewMode from "../../../pages/FormViewMode"
import PreferencePage from "../../../pages/Preferences/index"

export { Homepage, PermissionDenied, FormViewMode, PreferencePage }
